import React from "react";
import { createContext, useState } from 'react';
import { createPortal } from 'react-dom';
import {LoadingOverlay} from "../components/base/loadingOverlay/LoadingOverlay.jsx";

export const ApiContext = createContext(null);

export const ApiProvider = ({ children, apiInstance }) => {
    const [api, setApi] = useState(apiInstance);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    return (
        <ApiContext.Provider value={{ api, setApi, loading, setLoading, error, setError }}>
            {loading && createPortal(<LoadingOverlay />, document.body)}
            {children}
        </ApiContext.Provider>
    );
};